import React, { useEffect, useState } from 'react'; 
import { Link } from 'react-router-dom';  
import { getPrincipalMessage } from '../Service/Api'; 
const Gallery = () => {   
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true); 
  const [error, setError] = useState(null); // To handle errors

  useEffect(() => {
    const fetchData = async () => {
      try {
        const principalData = await getPrincipalMessage();
        
        setData(principalData);
      } catch (error) {
        console.log("Data Error", error);
        setError("Failed to fetch data."); // Set error state
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  const emptyData = [
    {
      id: 1,
      category: "Manager",
      attachments:""
    }
  ];
  const filteredData = data.filter(div => div.category === "Principal");
  return (
    <> 
    <div className="row">  
                <div className="col-xl-3 col-lg-6">
                {(filteredData.length > 0 ? filteredData : emptyData).map((item, index) => (
                <div className="galleryimg" key={item.id || index}>
                <div className="galleryimgbox">

                <img src={item.attachments ? `https://webapi.entab.info/api/image/${item.attachments}` : "https://webapi.entab.info/api/image/TAFS/public/Images/principal.jpg"}  alt="Message"  className="img-fluid"/>
  
              </div>  
              <h6><span>Principal's</span> Message</h6>
              <div className="gallerydesc">
                  <Link to="/PrincipalsMessage" className="gallery_button">Read More</Link> 
                </div>
              </div>
              ))}

             </div>
              <div className="col-xl-3 col-lg-6">
            <div className="galleryimg">
              <div className="galleryimgbox">
                <img
                  src="https://webapi.entab.info/api/image/TAFS/public/Images/gal1.jpg"
                  alt="The Air Force School " 
                  className="img-fluid"
                />  
            </div>  
            <h6><span>Mission</span> N-MOLE</h6>
            <div className="gallerydesc">
                <Link to="/CareerCornerMissionMole" className="gallery_button">Read More</Link> 
              </div>
            </div>
         
           </div>
            <div className="col-xl-3 col-lg-6">
          <div className="galleryimg boardingfac">
            <div className="galleryimgbox">
              <img
                src="https://webapi.entab.info/api/image/TAFS/public/Images/gal2.jpg"
                alt="The Air Force School " 
                className="img-fluid"
              /> 
          </div>  
          <h6><span>Boarding</span> Facilities <br/> (Home Away from Home)</h6> 
          <div className="gallerydesc">
             <Link to="/BoardingHouse" className="gallery_button">Read More</Link> 
            </div>
          </div>
        
         </div>
          <div className="col-xl-3 col-lg-6">
        <div className="galleryimg boardingfac">
          <div className="galleryimgbox">
            <img
              src="https://webapi.entab.info/api/image/TAFS/public/Images/gal3.jpg"
              alt="The Air Force School " 
              className="img-fluid"
            />  
        </div> 
        <h6><span>Knowledge </span>  Centre<br/>  (TAFS Library)</h6> 
        <div className="gallerydesc">
            <Link to="/Library" className="gallery_button">Read More</Link> 
          </div>
        </div>
       </div>
        </div>
    </>
  );
};

export default Gallery;
